module.exports = __webpack_public_path__ + "static/logo-1a8bc729b1c2d30f020a306578ece100.svg";